import React from "react";
import { Form, FormGroup, Label } from "reactstrap";

const AttachModal = ({ label, SelectComponent }) => {
    return (
        <Form>
            <FormGroup>
                <Label>{label}</Label>
                {SelectComponent}
            </FormGroup>
        </Form>
    );
};

export default AttachModal;